module.exports = __webpack_public_path__ + "static/media/2.b4d1facc.svg";